// extracted by mini-css-extract-plugin
module.exports = {"case-study":"CaseStudy_case-study__skbmo"};